import { css } from '@emotion/react';

import { paddingVariables, typography } from '~/src/styles/design-system';
import { breakpoints } from '~/src/styles/styled-mixins';
import { fontWeight } from '~/src/styles/styled-variables';

import { commonStyles as topLevelCommonStyles } from '../common-styles';

export const commonStyles = {
  title: css(typography.heading3, {
    color: 'var(--Dark-Text, #27292D)',
    paddingTop: '10px',
    paddingBottom: '10px',
    borderTop: '1px solid  #D3D3D3',
    borderBottom: '1px solid  #D3D3D3',
    gridArea: 'title',
    [breakpoints.minTablet]: [
      typography.heading2,
      {
        paddingTop: '20px',
        paddingBottom: '20px',
      },
    ],
    [breakpoints.minDesktop]: [
      typography.heading3,
      {
        borderTop: 'none',
        borderBottom: 'none',
        paddingTop: '0px',
        paddingBottom: '0px',
        textAlign: 'center',
      },
    ],
  }),
  price: css({
    color: 'var(--Dark-Text, #27292D)',
    fontFamily: 'Montserrat',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: fontWeight.bold,
    lineHeight: '20px',
    letterSpacing: '0.9px',
    gridArea: 'price',
    textAlign: 'center',
    [breakpoints.minTablet]: {
      fontSize: '32px',
      lineHeight: '50px',
      letterSpacing: '1.6px',
    },

    [breakpoints.minDesktop]: typography.heading1,
  }),
  mandala: css({
    display: 'none',
    [breakpoints.minDesktop]: {
      display: 'block',
      placeSelf: 'center',
      width: '85%',
      gridRow: '1 / -1',
    },
  }),
  benefits: css({
    gridArea: 'benefits',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    [breakpoints.minDesktop]: {
      alignSelf: 'center',
    },
  }),
  benefitsTitle: css({
    fontFamily: 'Montserrat',
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '40px',
    letterSpacing: '1.4px',
    display: 'none',
    color: 'var(--Grey-Text, #585858)',
    [breakpoints.minDesktop]: {
      display: 'block',
    },
  }),
  button: css({
    gridArea: 'button',
    [breakpoints.minDesktop]: {
      placeContent: 'center',
    },
  }),
  container: css(topLevelCommonStyles.contentPadding, topLevelCommonStyles.containerMaxWidth, {
    display: 'grid',
    gridTemplateAreas: `'.' 'title' '.' 'benefits' '.' 'price' '.' 'button' '.'`,
    gridTemplateRows: `${paddingVariables.p56} auto ${paddingVariables.p24} auto ${paddingVariables.p32} auto ${paddingVariables.p32} auto 0`,
    [breakpoints.minTablet]: {
      gridTemplateRows: `${paddingVariables.p80} auto ${paddingVariables.p32} auto ${paddingVariables.p56} auto ${paddingVariables.p24} auto ${paddingVariables.p80}`,
    },
    [breakpoints.minDesktop]: {
      margin: 'auto',
    },
  }),
  errorMsg: typography.bodyText,
};
